import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useState } from "react";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useTheme, useMediaQuery, Button } from "@mui/material";
 

export default function Subscription() { 
    const theme = useTheme();
   const mobilemd = useMediaQuery(theme.breakpoints.up("md"));
  
        const scrollRef = React.useRef(null);
      
        const scrollRight = () => {
          if (scrollRef.current) {
            scrollRef.current.scrollBy({ left: 100, behavior: "smooth" });
          }
        };
 
  const [current_activeTab, setcurrent_ActiveTab] = useState("Subscription History");
  const [current_activeTab1, setcurrent_ActiveTab1] = useState("Last 7 D");

  return (
    <>
      <div className='history_inner_tab' > 
            <div className='h_tabs'>
            <button
              className={`history_button ${current_activeTab === "Subscription History" ? "active" : ""}`}
              onClick={() => setcurrent_ActiveTab("Subscription History")}
            >
              Subscription History
            </button>
            <button
              className={`history_button bddr ${current_activeTab === "Redemption History" ? "active" : ""}`}
              onClick={() => setcurrent_ActiveTab("Redemption History")}
            >
              Redemption History
            </button> 
            <button
              style={{background:"transparent"}}
              className={`history_button ${current_activeTab1 === "Last 7 D" ? "active" : ""}`}
              onClick={() => setcurrent_ActiveTab1("Last 7 D")}
            >
              Last 7 D
            </button>
            <button
              style={{background:"transparent"}}
              className={`history_button ${current_activeTab1 === "Last 30 D" ? "active" : ""}`}
              onClick={() => setcurrent_ActiveTab1("Last 30 D")}
            >
              Last 30 D
            </button>
            <button
              style={{background:"transparent"}}
              className={`history_button ${current_activeTab1 === "Last 180 D" ? "active" : ""}`}
              onClick={() => setcurrent_ActiveTab1("Last 180 D")}
            >
              Last 180 D
            </button>
          <ChevronRightIcon sx={{display: !mobilemd ? 'block' : 'none'}} className="scroll-btn"  onClick={scrollRight} />

            </div>
            {current_activeTab === "Subscription History" && 
                <div className="table_height">
                <TableContainer className="history_table">
                  <Table>
                    <TableHead>
                      <TableRow className="fixed-top">
                        <TableCell className="fixed-left">Assets</TableCell>
                        <TableCell>Order Amount</TableCell>
                        <TableCell>Transaction Amount</TableCell>
                        <TableCell>Filled Qty</TableCell>
                        <TableCell>Avg. Filled Price</TableCell>
                        <TableCell>Trading Fee</TableCell>
                        <TableCell>Timestamp</TableCell>
                        <TableCell>Order ID</TableCell>
                        <TableCell>Order Status</TableCell>
                      </TableRow>
                    </TableHead>
                    {/* <TableBody>
                      {tableData.length > 0 ? (
                        tableData.map((row, index) => (
                          <TableRow key={index}>
                            <TableCell className="fixed-left">{row.assets}</TableCell>
                            <TableCell>{row.orderAmount}</TableCell>
                            <TableCell>{row.transactionAmount}</TableCell>
                            <TableCell>{row.filledQty}</TableCell>
                            <TableCell>{row.avgFilledPrice}</TableCell>
                            <TableCell>{row.tradingFee}</TableCell>
                            <TableCell>{row.timestamp}</TableCell>
                            <TableCell>{row.orderId}</TableCell>
                            <TableCell>{row.orderStatus}</TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={9} align="center">
                              <img src={nodata} alt="No Data" style={{ maxWidth: "100px" }} />
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody> */}
                  </Table>
                </TableContainer>
              </div>}
            {current_activeTab === "Redemption History" && 
                <div className="table_height">
                <TableContainer className="history_table">
                  <Table>
                    <TableHead>
                      <TableRow className="fixed-top">
                        <TableCell className="fixed-left">Assets</TableCell>
                        <TableCell>Order Quantity</TableCell>
                        <TableCell>Transaction Amount</TableCell>
                        <TableCell>Filled Qty</TableCell>
                        <TableCell>Avg. Filled Price</TableCell>
                        <TableCell>Trading Fee</TableCell>
                        <TableCell>Timestamp</TableCell>
                        <TableCell>Order ID</TableCell>
                        <TableCell>Order Status</TableCell>
                      </TableRow>
                    </TableHead>
                    {/* <TableBody>
                      {tableData1.length > 0 ? (
                        tableData1.map((row, index) => (
                          <TableRow key={index}>
                            <TableCell className="fixed-left">{row.assets}</TableCell>
                            <TableCell>{row.orderQuantity}</TableCell>
                            <TableCell>{row.transactionAmount}</TableCell>
                            <TableCell>{row.filledQty}</TableCell>
                            <TableCell>{row.avgFilledPrice}</TableCell>
                            <TableCell>{row.tradingFee}</TableCell>
                            <TableCell>{row.timestamp}</TableCell>
                            <TableCell>{row.orderId}</TableCell>
                            <TableCell>{row.orderStatus}</TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={9} align="center">
                              <img src={nodata} alt="No Data" style={{ maxWidth: "100px" }} />
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody> */}
                  </Table>
                </TableContainer>
              </div>}
      </div>
    </>
  );
}
